import {
    FIELD_MAX_NUMBER_OF_OPE_UNITS,
    FIELD_REQUIRED,
} from 'form/validation/validationMessages'
import * as Yup from 'yup'

export interface OpeUnitValues {
    selectedVehicleId: string
    year: string
    make: string
    model: string
    msrp: string | number | null
    asset_value: string | number | null
    equipmentType: string
    equipmentSubType: string
    sku: string | null
}

export const EMPTY_OPE_UNIT: OpeUnitValues = {
    selectedVehicleId: '',
    year: '',
    make: '',
    model: '',
    msrp: '',
    asset_value: '',
    equipmentType: '',
    equipmentSubType: '',
    sku: '',
}

export const INITIAL_OPE_UNITS: OpeUnitValues[] = [{ ...EMPTY_OPE_UNIT }]

const opeUnitSchema = Yup.object().shape({
    selectedVehicleId: Yup.string().required(FIELD_REQUIRED),
    year: Yup.string().required(FIELD_REQUIRED),
})

export function createOpeEquipmentValidator(maxItems?: number) {
    const units = Yup.array().of(opeUnitSchema).min(1, FIELD_REQUIRED)

    return Yup.object().shape({
        condition: Yup.string().required(FIELD_REQUIRED),
        opeUnits: maxItems
            ? units.max(maxItems, FIELD_MAX_NUMBER_OF_OPE_UNITS(maxItems))
            : units,
    })
}
